import { SendToast } from "@networkraildigitalfactory/components";
import { useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { usePDF } from "../useAPI";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const useGeneratePDF = (data, close) => {
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const [, getResults] = usePDF(
    {
      url: `generate`,
      method: "POST",
    },
    { manual: true }
  );

  const [, getDownloads] = usePDF(
    {
      url: `download`,
      method: "POST",
    },
    { manual: true }
  );

  const generatePDF = async () => {
    try {
      setIsGeneratingPDF(true);
      const { employeeName, contentType, year } = data;

      const [downloads, pdfData] = await Promise.all([
        getDownloads({ data }),
        getResults({ data }),
      ]);

      if (contentType === "reviews") {
        if (downloads.status === 200) {
          const bytes = new Uint8Array(downloads.data.Body.data);
          const blob = new Blob([bytes], { type: downloads.data.ContentType });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${employeeName.replace(/\ /g, "")}-review-evidence`;
          link.click();
        }
      }

      const fileName = `${employeeName.replace(/\ /g, "")}-${
        contentType.charAt(0).toUpperCase() + contentType.slice(1)
      }${year}`;

      if (pdfData.status === 200) {
        setIsGeneratingPDF(false);

        const downloadCb = () => {
          SendToast("Export successfully completed", "success");
        };

        try {
          pdfMake.createPdf(pdfData.data).download(fileName, downloadCb);
        } catch (err) {
          console.error(err);
        }
        document.querySelector("button[name=SearchButton]").click();
      } else if (pdfData.status === 204) {
        SendToast("No data stored on iPerform for this selection", "error");
        setIsGeneratingPDF(false);
      }
      close();
    } catch (e) {
      console.error(e);
      SendToast("Export failed", "error");
      setIsGeneratingPDF(false);
      close();
    }
  };

  return { generatePDF, isGeneratingPDF };
};

export default useGeneratePDF;
